<template>
  <div>
    <b-modal
      hide-header-close
      :visible="bindValue && isModalOpen"
      :size="size"
      :hide-header="hideHeader"
      :hide-footer="hideFooter"
      :no-close-on-backdrop="!closeableFromOutside"
      :style="{ display: 'none' }"
      :scrollable="scrollable"
      :no-fade="noFade"
      centered
      @hidden="$emit('hidden')"
      @show="$emit('show')"
      :id="modalId ? `${modalId}` : 'base-modal'"
    >
      <template #modal-header>
        <slot name="modal-header"></slot>
      </template>

      <template #modal-title>
        <slot name="modal-title"></slot>
      </template>

      <slot></slot>

      <template #modal-footer>
        <slot name="modal-footer"></slot>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { BModal } from 'bootstrap-vue';
  import store from '@/store';
  import { computed, onUnmounted } from '@vue/composition-api';

  export default {
    props: {
      modalId: String,
      hideFooter: Boolean,
      hideHeader: Boolean,
      scrollable: Boolean,
      noFade: Boolean,
      bindValue: { type: Boolean, default: true },
      closeableFromOutside: {
        type: Boolean,
        default() {
          return true;
        },
      },
      size: {
        type: String,
        validator(value) {
          // The value must match one of these strings
          return ['xl', 'lg', 'sm'].includes(value);
        },
        default() {
          return 'sm';
        },
      },
    },
    components: { BModal },

    setup() {
      const isModalOpen = computed(() => {
        return store.getters['baseComponent/isModalOpen'];
      });

      const resolveCssVariables = computed(() => {
        let cssVariables = store.getters['appConfig/cssVariables'];
        return cssVariables;
      });

      onUnmounted(() => {
        store.commit('baseComponent/CLOSE_MODAL');
      });

      return { isModalOpen, resolveCssVariables };
    },
  };
</script>

<style>
  /* #base-modal___BV_modal_outer_ {
    z-index: 2000000 !important;
  }

  #base-modal > div > div > header {
    border: none;
    background: transparent;
  }

  #base-modal > div > div > footer {
    border: none;
  }

  .modal-title {
    font-size: 1.2rem;
  } */
</style>

<style scoped>
  @import '~@/assets/css/override-styles/base-modal.css';
</style>
